export default __webpack_public_path__ + "static/media/open-bin.ccb73794.png";